const UNBIND_SUBCATEGORIES = "UNBIND_SUBCATEGORIES";
const UNBIND_SUBCATEGORIES_SUCCESS = "UNBIND_SUBCATEGORIES_SUCCESS";
const UNBIND_SUBCATEGORIES_FAILURE = "UNBIND_SUBCATEGORIES_FAILURE";
const CLEAR_UNBIND_SUBCATEGORIES = "CLEAR_UNBIND_SUBCATEGORIES";

const unbindSubcategoriesSymbols = {
  UNBIND_SUBCATEGORIES_SUCCESS,
  UNBIND_SUBCATEGORIES_FAILURE,
  UNBIND_SUBCATEGORIES,
  CLEAR_UNBIND_SUBCATEGORIES,
};
export default unbindSubcategoriesSymbols;
